import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import withRow from "../../../../components/withRow";

import { useTranslation } from "react-i18next";

const ChildRow = (props) => <Row className="mb-3 mx-0" {...props} />;

const Child = ({
  size,
  institutionalEmail,
  institutionalWebsite,
  updateMultipleValues,
}) => {
  const { t } = useTranslation('translation', {keyPrefix: 'emailWebsiteInput'})
  return (
    <>
      <Form.Group
        as={size !== "xs" && size !== "sm" ? Col : ChildRow}
        controlId="formInstitutionalWebsite"
      >
        <Form.Label className="ps-0">{t('website')}</Form.Label>
        <Form.Control
          type="url"
          pattern="https?://.*"
          placeholder="https://www.auth.gr/en/"
          value={institutionalWebsite}
          required
          onChange={(e) =>
            updateMultipleValues({ institutionalWebsite: e.target.value })
          }
        />
        <Form.Control.Feedback type="invalid">
          {t('websiteError')}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group
        as={size !== "xs" && size !== "sm" ? Col : ChildRow}
        controlId="formContactInstitutionalEmail"
      >
        <Form.Label className="ps-0">{t('email')}</Form.Label>
        <Form.Control
          type="email"
          placeholder="example@auth.gr"
          value={institutionalEmail}
          required
          onChange={(e) =>
            updateMultipleValues({ institutionalEmail: e.target.value })
          }
        />
        <Form.Control.Feedback type="invalid">
          {t('emailError')}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

const EmailWebsiteInput = (props) => {
  return withRow(Child, props.size !== "xs" && props.size !== "sm")(props);
};

export default EmailWebsiteInput;
